import EnumDataSource from "utils/enum-data-source.util";

export const QUICKBOOKS_INVENTORY_PRODUCT_TYPE = 1;
export const QUICKBOOKS_NON_INVENTORY_PRODUCT_TYPE = 2;
export const QUICKBOOKS_SERVICE_PRODUCT_TYPE = 3;
export const QUICKBOOKS_GROUP_PRODUCT_TYPE = 4;
export const QUICKBOOKS_CATEGORY_PRODUCT_TYPE = 5;

export const QUICKBOOKS_PRODUCT_TYPES = new EnumDataSource({
  [QUICKBOOKS_INVENTORY_PRODUCT_TYPE]: "Inventory",
  [QUICKBOOKS_NON_INVENTORY_PRODUCT_TYPE]: "NonInventory",
  [QUICKBOOKS_SERVICE_PRODUCT_TYPE]: "Service",
  [QUICKBOOKS_GROUP_PRODUCT_TYPE]: "Group",
  [QUICKBOOKS_CATEGORY_PRODUCT_TYPE]: "Category",
});
